import ListTreatabilityMatches from './ListTreatabilityMatches';

export default ListTreatabilityMatches;
